module.exports = require("@comparaonline/cicl-funnel-schema");